import { useEffect, useState } from 'react';

/** Floating "TOP" button for long mobile lists; appears once the page is scrolled past 300px. */
function ScrollTopButton({ enabled }: { enabled: boolean }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!enabled) {
            setVisible(false);
            return;
        }
        const handleScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [enabled]);

    if (!enabled || !visible) return null;

    return (
        <button
            type='button'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className='fixed bottom-6 right-4 z-[60] flex h-12 w-12 items-center justify-center rounded-full bg-[#3F8EE8] text-xs font-semibold text-white shadow-lg transition hover:bg-[#2F7BD0]'
            aria-label='Back to top'
        >
            TOP
        </button>
    );
}

export default ScrollTopButton;
